import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { aiReportTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const TOAST_ID = 'create-page-report';

export const createPageReport: aiReportTypes.CreateReport = (params) => {
  return axios.post('/page-reports', params);
};

type MutationFnType = typeof createPageReport;

type UseCreatePageReportOptions = {
  config?: MutationConfig<MutationFnType>;
};

export const useCreatePageReport = ({ config = {} }: UseCreatePageReportOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: createPageReport,
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Ставим отчёт в очередь...');
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['page-reports']);
      toasts.loadingToast.success(TOAST_ID, 'Отчёт поставлен в очередь');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error?: string }>, ...args) => {
      if (error.response?.status === 409) {
        notifications.hide(TOAST_ID);
      } else {
        toasts.loadingToast.error(TOAST_ID, error.response?.data?.error);
      }
      config.onError?.(error, ...args);
    },
  });
};
